/**
 * Visual treatment shared by the widget's link-styled controls (Back, Change
 * details): body-sized primary-coloured text that underlines on hover, with a
 * focus ring for keyboard users.
 */
export const LINK_BUTTON =
  "gcw:flex gcw:items-center gcw:gap-1 gcw:text-body gcw:font-medium gcw:text-primary gcw:hover:underline gcw:focus:outline-none gcw:focus:ring-2 gcw:focus:ring-primary gcw:focus:ring-offset-1 gcw:rounded-md";
